import Vue from 'vue/dist/vue.esm'
import BootstrapVue from 'bootstrap-vue'
import VueResource from 'vue-resource'

import UploadManager from './components/Contributors/Onboarding/OnboardingUploadManager'
import FileInput from './components/Common/FileInput'
import ImportMembers from "./components/Customers/Account/ImportMembers";
import SampleImageRejectForm from './components/Contributors/SampleImages/SampleImageRejectForm'
import SubmissionAssets from './components/Contributors/Submissions/SubmissionAssets'
import SubmissionCuratorAsset from './components/Curators/Submissions/SubmissionCuratorAsset'
import SubmissionCuratorAssets from './components/Curators/Submissions/SubmissionCuratorAssets'
import SubmissionCuratorAssetsV2 from './components/Curators/Submissions/SubmissionCuratorAssetsV2'
import EditReleaseForms from './components/Contributors/Assets/EditReleaseForms'
import SearchAssetsList from './components/Search/SearchAssetsList'
import FeaturedItem from "./components/Common/FeaturedItem";
import FeaturedAsset from "./components/Curators/Assets/FeaturedAsset";
import normalize from 'json-api-normalize'
import Attributes from "./models/Attributes";
import ModalNavigation from "./components/Common/ModalNavigation"
import PaymentMethodManager from "./components/Customers/PaymentMethods/PaymentMethodManager"
import PaymentManager from "./components/Customers/Payments/PaymentManager";
import OrganizationBilling from "./components/Customers/Billing/OrganizationBilling";
import ProjectForm from "./components/Customers/Projects/ProjectForm";
import AddToProject from "./components/Customers/Dashboard/AddToProject";
import SingleImagePurchaseForm from "./components/Customers/Assets/SingleImagePurchaseForm";
import CustomerEditProfile from "./components/Customers/Account/EditProfile";
import CustomerEditAvatar from "./components/Customers/Account/EditAvatar";
import SwitchInput from "./components/Common/SwitchInput";
import SwitchInputBooleanRadio from "./components/Common/SwitchInputBooleanRadio";
import CustomerEditOrganization from "./components/Customers/Account/EditOrganization";
import PortalVue from 'portal-vue'
import Rollbar from 'vue-rollbar'
import vueCountryRegionSelect from 'vue-country-region-select'
import AssetSearchApp from './components/AssetSearch/AssetSearch';
import CuratorAssetSearchApp from './components/Curators/AssetSearch/App';
import CollectionForm from "./components/Curators/Collections/CollectionForm";
import CuratorCollectionAssets from "./components/Curators/Collections/Assets"
import InstantSearch from 'vue-instantsearch';
import Plans from "./components/Customers/Subscriptions/Plans";
import NewSubscription from "./components/Customers/Subscriptions/NewSubscription";
import EditSubscription from "./components/Customers/Subscriptions/EditSubscription";
import GenericModal from "./components/Common/GenericModal";
import GenericFormModal from "./components/Common/GenericFormModal";
import GroupedTokensPopover from "./components/Customers/Subscriptions/GroupedTokensPopover.vue";
import LicenseAgreementForm from "./components/Curators/LicenseAgreements/LicenseAgreementForm";
import AdminSubscriptionPrefill from "./components/Curators/Subscriptions/Prefill";
import POCConfig from "../config.js.erb";
import VuePlyr from 'vue-plyr'
import Plyr from 'plyr'
import VideoPlayer from "./components/Common/VideoPlayer";
import ContributorEarningExport from "./components/Contributors/Earnings/EarningExport";
import DashboardTableSelector from "./components/Curators/Dashboard/DashboardTableSelector.vue";
import AgencyRegistration from "./components/Customers/Agencies/Registration.vue";
import AgencySelect from "./components/Curators/Organizations/AgencySelect.vue";
import ProjectShareWidget from "./components/Customers/Projects/ProjectShareWidget.vue";
import VideoHoverPlayer from "./components/Common/VideoHoverPlayer.vue";
import CopyIcon from "./components/Common/CopyIcon.vue";
import DropdownSelect from "./components/Common/DropdownSelect.vue";
import UserAccountCheckboxSelect from "./components/Common/UserAccountCheckboxSelect.vue";
import OnboardingPopup from "./components/Customers/Onboarding/OnboardingPopup.vue";
import OnboardingPlans from "./components/Customers/Onboarding/OnboardingPlans.vue";
import OnboardingPricingPagePaymentModalContainer from "./components/Customers/Onboarding/OnboardingPricingPagePaymentModalContainer.vue";
import OnboardingPopupPaymentModalContainer from "./components/Customers/Onboarding/OnboardingPopupPaymentModalContainer.vue";
import OnboardingNameEditPopup from "./components/Customers/Onboarding/OnboardingNameEditPopup.vue";
import UpdatePlan from "./components/Customers/Subscriptions/UpdatePlan.vue";
import OrganizationBillingV2 from "./components/Customers/Billing/OrganizationBillingV2.vue";
import PaymentMethodAdd from "./components/Customers/PaymentMethods/PaymentMethodAdd.vue";
import EditAvatar from "./components/Customers/Account/EditAvatar.vue";
import OnboardingInterestsModalWrapper from "./components/Customers/Onboarding/OnboardingInterestsModalWrapper.vue";
import DeleteAccount from "./components/Customers/Account/DeleteAccount.vue";
import DownloadDataRequest from "./components/Customers/Account/DownloadDataRequest.vue";
import CancelSubscription from "./components/Customers/Subscriptions/CancelSubscription.vue";
import AddPlanModalContainer from "./components/Customers/Subscriptions/AddPlanModalContainer.vue";
import RequestQuoteApp from "./components/RequestQuote/RequestQuoteApp.vue";
import DiversityLens from "./components/Public/DiversityLens.vue";
import DiversityLensImageSlider from "./components/Public/DiversityLensImageSlider.vue";
import PasswordFieldContainer from "./components/Customers/Account/PasswordFieldContainer.vue";
import MasonryWall from "./components/Common/MasonryWall.vue";
import HeavyRenderLoader from "./components/Common/HeavyRenderLoader.vue";

Vue.use(vueCountryRegionSelect);
Vue.use(InstantSearch);

if (typeof _rollbarConfig !== 'undefined') {
  Vue.use(Rollbar, _rollbarConfig);
  Vue.config.errorHandler = function (err, vm, info) {
    console.log(err);
    Vue.rollbar.error(err);
  };
}

Vue.use(PortalVue);
Vue.use(BootstrapVue);
Vue.use(VueResource);
Vue.use(VuePlyr, {
  plyr: {}
});

Vue.component('masonry-wall', MasonryWall);
Vue.component('generic-form-modal', GenericFormModal);
Vue.component('generic-modal', GenericModal);
Vue.component('license-agreement-form', LicenseAgreementForm);
Vue.component('admin-subscription-prefill', AdminSubscriptionPrefill);
Vue.component('import-members', ImportMembers);
Vue.component('contributor-earning-export', ContributorEarningExport);
Vue.component('grouped-tokens-popover', GroupedTokensPopover);
Vue.component('dashboard-table-selector', DashboardTableSelector);
Vue.component('agency-registration', AgencyRegistration)
Vue.component('agency-select', AgencySelect)
Vue.component('project-share-widget', ProjectShareWidget)
Vue.component('video-hover-player', VideoHoverPlayer)
Vue.component('copy-icon', CopyIcon)
Vue.component('dropdown-select', DropdownSelect)
Vue.component('user-account-checkbox-select', UserAccountCheckboxSelect)
Vue.component('onboarding-popup', OnboardingPopup)
Vue.component('onboarding-plans', OnboardingPlans)
Vue.component('onboarding-pricing-page-payment-modal-container', OnboardingPricingPagePaymentModalContainer)
Vue.component('onboarding-popup-payment-modal-container', OnboardingPopupPaymentModalContainer)
Vue.component('onboarding-name-edit-popup', OnboardingNameEditPopup)
Vue.component('update-plan', UpdatePlan)
Vue.component('organization-billing-v2', OrganizationBillingV2)
Vue.component('payment-method-add', PaymentMethodAdd)
Vue.component('edit-avatar', EditAvatar)
Vue.component('onboarding-interests-modal-wrapper', OnboardingInterestsModalWrapper)
Vue.component('delete-account', DeleteAccount)
Vue.component('download-data-request', DownloadDataRequest)
Vue.component('cancel-subscription', CancelSubscription)
Vue.component('add-plan-modal-container', AddPlanModalContainer)
Vue.component('request-quote-app', RequestQuoteApp)
Vue.component('diversity-lens', DiversityLens)
Vue.component('diversity-lens-image-slider', DiversityLensImageSlider)
Vue.component('password-field-container', PasswordFieldContainer)
Vue.component('heavy-render-loader', HeavyRenderLoader)

const editAssetDataJson = function (element) {
  if (element !== undefined && element !== null) {
    let data = {};

    if (element.dataset.tagsByCategory) {
      data = {...buildTagsDataObject(JSON.parse(element.dataset.tagsByCategory))};
    }

    if (element.dataset.categories) {
      const categoriesJson = JSON.parse(element.dataset.categories);
      if (!window.categoriesStore.categories) {
        window.categoriesStore.categories = categoriesJson
      }

      Object.freeze(categoriesJson);
      data.categories = categoriesJson;
    }

    if (element.dataset.submission) {
      const submissionJson = JSON.parse(element.dataset.submission);
      Object.freeze(submissionJson);
      data.submission = submissionJson;
    }

    const assetAttrs = Attributes.assetWithIncludesAttributes;

    if (element.dataset.assets) {
      data.assets = normalize(JSON.parse(element.dataset.assets)).get(assetAttrs);
    } else if (element.dataset.asset) {
      data.assets = [normalize(JSON.parse(element.dataset.asset)).get(assetAttrs)];
    }

    if (element.dataset.invalidAssetIds) {
      data.invalidAssetIds = JSON.parse(element.dataset.invalidAssetIds);
    }

    if (element.dataset.submissionReleaseForms) {
      data.submissionReleaseForms = normalize(JSON.parse(element.dataset.submissionReleaseForms)).get(Attributes.releaseFormAttributes)
    }
    return data;
  }
};

const assetsListJson = function (element) {
  const attrs = Attributes.assetAttributes
    .concat(Attributes.prefixed('tags.tag_category', Attributes.tagCategoryAttributes))
    .concat(Attributes.prefixed('tags', Attributes.tagAttributes))
    .concat(Attributes.prefixed('categories', Attributes.categoryAttributes));
  return normalize(JSON.parse(element.dataset.assets)).get(attrs);
};

const buildTagsDataObject = function (allTagsByCategory) {
  return {
    tagsByCategory: allTagsByCategory
  }
};

window.reasonStore = {
  availableReasons(status) {
    if (status === 'changes_requested') {
      return this.curatorRequestReasons || []
    } else if (status === 'rejected') {
      return this.curatorRejectReasons || []
    } else if (status === 'deactivated') {
      return this.curatorAssetRemovalReasons || []
    }
    return []
  }
}

window.categoriesStore = {
  findCategory(id) {
    if (this.categories) {
      return this.categories.find(cat => cat.id === id)
    }
    return null
  }
}

window.tagStore = {
  updateWithAllTagsByCategory(allTagsByCategory) {
    const data = buildTagsDataObject(allTagsByCategory);
    this.updateWithTagStoreDataObject(data);
  },

  updateWithTagStoreDataObject(data) {
    this.tagsByCategory = this.sortedTagCategories(["Ethnicity"], data.tagsByCategory);
  },

  findTag(id) {
    for (const tagName of Object.keys(this.tagsByCategory)) {
      let tag = this.tagsByCategory[tagName].tags.find(t => t.id === id)
      if (tag) {
        return {
          tag: tag,
          categoryName: tagName
        }
      }
    }

    return null
  },

  sortedTagCategories(categories, tagsByCategory) {
    Array(categories).forEach(categoryName => {
      const tagCategory = tagsByCategory[categoryName]
      if (!tagCategory) return;
      const tags = tagCategory.tags
      tagCategory.tags = tags.sort((a, b) => {
        if (a.name.toLowerCase() < b.name.toLowerCase()) {
          return -1;
        }
        if (a.name.toLowerCase() > b.name.toLowerCase()) {
          return 1;
        }
        return 0;
      })
    })
    return tagsByCategory
  }
};

window.projectsStore = {
  projects: [],
  vue: new Vue(),
  updateProject(project) {
    const existingProject = this.projects.find(p => p.id === project.id);
    if (existingProject) {
      this.vue.$set(this.projects, this.projects.indexOf(existingProject), project);
    }
  }
};

window.collectionsStore = {
  collections: [],
  vue: new Vue(),
  updateCollection(collection) {
    const existingCollection = this.collections.find(p => p.id === collection.id);
    if (existingCollection) {
      this.vue.$set(this.collections, this.collections.indexOf(existingCollection), collection);
    }
  }
};

const initializeUploader = function () {
  const element = document.querySelector('#onboarding-sample-images');

  if (element !== undefined && element !== null) {
    const filesJson = JSON.parse(element.dataset.files);
    new Vue({
      el: element,
      data: {
        files: filesJson.data,
        url: element.dataset.url,
        paramName: element.dataset.paramName,
        acceptedFiles: element.dataset.acceptedFiles
      },
      template: `
        <UploadManager :initial-files="files"
                       :url="url"
                       max-files="3"
                       drop-area="body"
                       :param-name="paramName"
                       :accepted-files="acceptedFiles"/>`,
      components: {UploadManager}
    })
  }
};

const initializeFileInput = function () {
  const nodeList = document.querySelectorAll('.poc-file-input');
  Array.from(nodeList).forEach(element => {
    new Vue({
      el: element,
      data: {
        paramName: element.dataset.paramName,
        label: element.dataset.label,
        accept: element.dataset.accept,
      },
      template: `
        <FileInput :param-name="paramName" :label="label" :accept="accept"/>`,
      components: {FileInput}
    })
  });
};

const initializeSampleAssetRejectForm = function () {
  const nodeList = document.querySelectorAll('.poc-sample-image-reject-input');
  Array.from(nodeList).forEach(element => {
    new Vue({
      el: element,
      data: {
        paramName: element.dataset.paramName,
        targetImg: element.dataset.targetImg,
        assetType: element.dataset.assetType,
        targetStatus: element.dataset.targetStatus,
      },
      template: `
        <SampleImageRejectForm :param-name="paramName"
                               :target-img="targetImg"
                               :asset-type="assetType"
                               :target-status="targetStatus"/>`,
      components: {SampleImageRejectForm}
    })
  })
};

const initializeSubmissionUploader = function () {
  const element = document.querySelector('#submission-assets-container');
  if (element !== undefined && element !== null) {
    const dataJson = editAssetDataJson(element);
    window.tagStore.updateWithTagStoreDataObject(dataJson);
    new Vue({
      el: element,
      data: {
        ...dataJson,
        assetType: element.dataset.assetType,
        url: element.dataset.url,
        releaseFormUrl: element.dataset.releaseFormUrl,
        paramName: element.dataset.paramName,
        addAssetsHint: element.dataset.addAssetsHint,
        tagStore: window.tagStore,
        maxFiles: element.dataset.maxFiles || 0,
        maxFileSize: element.dataset.maxFileSize || 0
      },
      template: `
        <SubmissionAssets
            :asset-type="assetType"
            :assets="assets"
            :submission="submission"
            :tag-store="tagStore"
            :invalid-asset-ids="invalidAssetIds"
            :categories="categories"
            :url="url"
            :release-form-url="releaseFormUrl"
            :param-name="paramName"
            drop-area=".my-assets-dropzone"
            :add-assets-hint="addAssetsHint"
            :submission-release-forms="submissionReleaseForms"
            :max-files="maxFiles"
            :max-file-size="maxFileSize"/>`,
      components: {SubmissionAssets: SubmissionAssets}
    })
  }
};

const initializeSearchAssetsList = function () {
  const element = document.querySelector('#search-images-list');
  if (element !== undefined && element !== null) {
    const assetsJson = assetsListJson(element);
    const projectJson = element.dataset.project ? normalize(JSON.parse(element.dataset.project)).get(Attributes.projectAttributes) : null;
    const favoritesJson = element.dataset.favorites ? normalize(JSON.parse(element.dataset.favorites)).get(Attributes.favoriteAttributes) : [];
    const licensesJson = element.dataset.licenses ? normalize(JSON.parse(element.dataset.licenses)).get(Attributes.licenseAttributes) : [];
    const enabledActions = element.dataset.enabledActions ? JSON.parse(element.dataset.enabledActions) : {};

    new Vue({
      el: element,
      data: {
        assets: assetsJson,
        tagCategoryPriority: JSON.parse(element.dataset.tagCategoryPriority),
        originalFavorites: favoritesJson,
        project: projectJson,
        projectsUrl: element.dataset.projectsUrl,
        projectAssetsUrl: element.dataset.projectAssetsUrl,
        listType: element.dataset.listType,
        enabledActions: enabledActions,
        licenses: licensesJson,
        assetDownloadRoute: element.dataset.assetDownloadRoute
      },
      template: `
        <SearchAssetsList :assets="assets"
                          :list-type="listType"
                          :tag-category-priority="tagCategoryPriority"
                          :projects-url="projectsUrl"
                          :project="project"
                          :enabled-actions="enabledActions"
                          :project-assets-url="projectAssetsUrl"
                          :licenses="licenses"
                          :asset-download-route="assetDownloadRoute"
                          :original-favorites="originalFavorites"/>`,
      components: {SearchAssetsList}
    })
  }
};

const initializeModalImages = function () {
  const nodeList = document.querySelectorAll('.poc-modal-image');
  Array.from(nodeList).forEach(element => {
    new Vue({
      el: element,
      components: {VideoPlayer},
      data: {
        src: element.dataset.src,
        name: element.dataset.name,
        assetType: element.dataset.assetType,
        footerHTML: element.dataset.footer,
        footerClass: element.dataset.footerClass,
        show: false,
        id: element.dataset.id,
        elementClassName: element.className
      },

      computed: {
        isVideo() {
          return this.assetType && this.assetType.toLowerCase() === "video"
        }
      },

      template: `
        <div :class="elementClassName" @click="show = true">
        <b-modal :title="name"
                 v-model="show"
                 :hide-footer="!footerHTML"
                 :footer-class="footerClass"
                 no-fade
                 size="lg"
                 centered
                 scrollable>
          <div class="d-flex justify-content-between">
            <div class="flex-grow-1 d-flex justify-content-center">
              <video-player v-if="isVideo"
                            :url="src"/>
              <b-img v-else :src="src" fluid/>
            </div>
          </div>
          <template v-slot:modal-footer>
            <div class="w-100" v-html="footerHTML"></div>
          </template>
        </b-modal>
        </div>`
    })
  })
};

const initializeModalAssets = function () {
  const nodeList = document.querySelectorAll('.poc-modal-asset');

  Array.from(nodeList).forEach(element => {
    const attrs = Attributes.assetAttributes
    const asset = normalize(JSON.parse(element.dataset.asset)).get(attrs);
    if (!asset) {
      return;
    }

    new Vue({
      el: element,
      components: {VideoPlayer},
      data: {
        asset: asset,
        footerHTML: element.dataset.footer,
        footerClass: element.dataset.footerClass,
        show: false,
        elementClassName: element.className
      },

      computed: {
        isVideo() {
          return this.asset.asset_type === "Video"
        }
      },

      template: `
        <div :class="elementClassName" @click="show = true">
        <b-modal :title="asset.name"
                 v-model="show"
                 :hide-footer="!footerHTML"
                 :footer-class="footerClass"
                 no-fade
                 size="lg"
                 centered
                 scrollable>
          <div class="d-flex justify-content-between">
            <div class="flex-grow-1 d-flex justify-content-center">
              <video-player v-if="isVideo"
                            :thumb-url="asset.thumb_url"
                            :url="asset.media_thumb_url"/>
              <b-img v-else :src="asset.watermark_medium_url" fluid/>
            </div>
          </div>
          <template v-slot:modal-footer>
            <div class="w-100" v-html="footerHTML"></div>
          </template>
        </b-modal>
        </div>`
    })
  })
};

const initializeEditReleaseForms = function () {
  const element = document.querySelector('#edit-asset-release-forms');

  if (element !== undefined && element !== null) {
    const attrs = Attributes.assetAttributes.concat(Attributes.prefixed('release_forms', Attributes.releaseFormAttributes));
    const asset = normalize(JSON.parse(element.dataset.asset)).get(attrs);
    const releaseForms = normalize(JSON.parse(element.dataset.submissionReleaseForms)).get(Attributes.releaseFormAttributes);
    new Vue({
      el: element,
      data: {
        assetUrl: element.dataset.assetUrl,
        releaseFormUrl: element.dataset.releaseFormUrl,
        asset: asset,
        acceptedFiles: element.dataset.acceptedFiles,
        submissionReleaseForms: releaseForms
      },
      template: `
        <EditReleaseForms :asset="asset"
                          :asset-url="assetUrl"
                          :release-form-url="releaseFormUrl"
                          :submission-release-forms="submissionReleaseForms"
                          :accepted-files="acceptedFiles"/>`,
      components: {EditReleaseForms}
    })
  }
};

const initializeCuratorAssets = function () {
  const element = document.querySelector('#curator-submission-images-container');
  if (element !== undefined && element !== null) {
    const dataJson = editAssetDataJson(element);
    window.tagStore.updateWithTagStoreDataObject(dataJson);
    new Vue({
      el: element,
      data: {
        ...dataJson,
        url: element.dataset.url,
        submissionsUrl: element.dataset.submissionsUrl,
        tagStore: window.tagStore
      },
      template: `
        <SubmissionCuratorAssets :tag-store="tagStore"
                                 :assets="assets"
                                 :categories="categories"
                                 :submissions-url="submissionsUrl"
                                 :url="url"/>`,
      components: {SubmissionCuratorAssets: SubmissionCuratorAssets}
    })
  }
};

const initializeCuratorAssetsV2 = function () {
  const element = document.querySelector('#curator-submission-images-container-v2');
  if (element !== undefined && element !== null) {
    const dataJson = editAssetDataJson(element);
    window.tagStore.updateWithTagStoreDataObject(dataJson);

    loadReasonStore(element)

    new Vue({
      el: element,
      data: {
        ...dataJson,
        url: element.dataset.url,
        submissionId: element.dataset.submissionId,
        submissionsUrl: element.dataset.submissionsUrl,
        tagStore: window.tagStore,
        tagCategoryOrder: JSON.parse(element.dataset.tagCategoryOrder),
        releaseFormUrl: element.dataset.releaseFormUrl
      },
      template: `
        <SubmissionCuratorAssetsV2 :tag-store="tagStore"
                                   :assets="assets"
                                   :submission-id="submissionId"
                                   :categories="categories"
                                   :submissions-url="submissionsUrl"
                                   :tag-category-order="tagCategoryOrder"
                                   :release-form-url="releaseFormUrl"
                                   :submission-release-forms="submissionReleaseForms"
                                   :url="url"/>`,
      components: {SubmissionCuratorAssetsV2: SubmissionCuratorAssetsV2}
    })
  }
};

const initializeCuratorSingleAssetEdit = function () {
  const element = document.querySelector('#curator-image-container');
  if (element !== undefined && element !== null) {
    const dataJson = editAssetDataJson(element);
    window.tagStore.updateWithTagStoreDataObject(dataJson);
    new Vue({
      el: element,
      data: {
        ...dataJson,
        url: element.dataset.url,
        tagStore: window.tagStore,
        releaseFormUrl: element.dataset.releaseFormUrl
      },
      template: `
        <b-card class="mt-3">
        <SubmissionCuratorAsset v-for="file in assets"
                                :asset="file"
                                :key="file.id"
                                :tag-store="tagStore"
                                :categories="categories"
                                :expanded="true"
                                :release-form-url="releaseFormUrl"
                                :submission-release-forms="submissionReleaseForms"
                                :should-prevent-save-loss="true"
                                :url="url"/>
        </b-card>`,
      components: {SubmissionCuratorAsset: SubmissionCuratorAsset}
    })
  }
};

const initializeModalNavigation = function () {
  const element = document.querySelector('.modal-navigation');
  if (element !== undefined && element !== null) {
    const assetsJson = assetsListJson(element);

    new Vue({
      el: element,
      data: {
        assets: assetsJson,
        tagCategoryPriority: JSON.parse(element.dataset.tagCategoryPriority)
      },
      template: `
        <ModalNavigation :assets="assets" :tag-category-priority="tagCategoryPriority"/>`,
      components: {ModalNavigation}
    })
  }
};

const initializeFeaturedItems = function () {
  const nodeList = document.querySelectorAll('.featured-item');
  Array.from(nodeList).forEach(element => {
    new Vue({
      el: element,
      data: {
        url: element.dataset.url,
        featured: element.dataset.featured,
        itemType: element.dataset.itemType
      },
      template: `
        <FeaturedItem :url="url" :featured="featured" :item-type="itemType"/>`,
      components: {FeaturedItem}
    })
  });
};

const initializeFeaturedAssets = function () {
  const nodeList = document.querySelectorAll('.featured-image');
  Array.from(nodeList).forEach(element => {
    const featuredAsset = element.dataset.featuredAsset ? normalize(JSON.parse(element.dataset.featuredAsset)).get(Attributes.featuredAssetAttributes) : {};

    new Vue({
      el: element,
      data: {
        url: element.dataset.url,
        featuredAsset: featuredAsset,
        assetId: element.dataset.assetId
      },
      template: `
        <FeaturedAsset :url="url" :featured-asset="featuredAsset" :asset-id="assetId"/>`,
      components: {FeaturedAsset}
    })
  });
};

const initializePaymentMethod = function () {
  const element = document.querySelector('#payment-method');
  if (element !== undefined && element !== null) {

    const paymentMethods = normalize(JSON.parse(element.dataset.paymentMethods)).get(Attributes.paymentMethodAttributes);
    const organization = normalize(JSON.parse(element.dataset.organization)).get(Attributes.organizationAttributes);

    new Vue({
      el: element,
      data: {
        paymentMethodsUrl: element.dataset.paymentMethodsUrl,
        paymentMethods: paymentMethods,
        maxPaymentMethods: parseInt(element.dataset.maxPaymentMethods, 10),
        organization: organization
      },
      template: `
        <PaymentMethodManager :payment-methods-url="paymentMethodsUrl"
                              :organization="organization"
                              :max-payment-methods="maxPaymentMethods"
                              :initial-payment-methods="paymentMethods"/>`,
      components: {PaymentMethodManager}
    })
  }
};

const initializeOrganizationBilling = function () {
  const element = document.querySelector('#organization-billing');
  if (element !== undefined && element !== null) {
    const organization = normalize(JSON.parse(element.dataset.organization)).get(Attributes.organizationAttributes);

    new Vue({
      el: element,
      data: {
        organizationUrl: element.dataset.organizationUrl,
        organization: organization
      },

      template: `
        <OrganizationBilling :organization-url="organizationUrl"
                             :initial-organization="organization"/>`,
      components: {OrganizationBilling}
    })
  }
};

const initializePaymentManager = function () {
  const element = document.querySelector('#payment-manager');
  if (element !== undefined && element !== null) {

    const paymentMethods = normalize(JSON.parse(element.dataset.paymentMethods)).get(Attributes.paymentMethodAttributes);
    const payment = normalize(JSON.parse(element.dataset.payment)).get(Attributes.paymentAttributes);
    const organization = normalize(JSON.parse(element.dataset.organization)).get(Attributes.organizationAttributes)

    new Vue({
      el: element,
      data: {
        paymentMethods: paymentMethods,
        payment: payment,
        clientSecret: element.dataset.clientSecret,
        successUrl: element.dataset.successUrl,
        amount: element.dataset.amount,
        organization: organization
      },
      template: `
        <PaymentManager :payment-methods="paymentMethods"
                        :success-url="successUrl"
                        :payment="payment"
                        :organization="organization"
                        :amount="amount"
                        :client-secret="clientSecret"/>`,
      components: {PaymentManager}
    })
  }
};

const initializeProjectForm = function () {
  const nodeList = document.querySelectorAll('[data-behavior="project-form"]');
  Array.from(nodeList).forEach(element => {
    const project = element.dataset.project ? normalize(JSON.parse(element.dataset.project)).get(Attributes.projectAttributes) : null
    const defaultPermissions = {
      delete: false
    }

    const permissions = element.dataset.permissions ? JSON.parse(element.dataset.permissions) : defaultPermissions;
    const newButtonTitle = element.dataset.newButtonTitle
    const newButtonVariant = element.dataset.newButtonVariant

    new Vue({
      el: element,
      data: {
        url: element.dataset.url,
        project: project,
        triggerHtml: element.dataset.triggerHtml,
        newButtonTitle: newButtonTitle,
        newButtonVariant: newButtonVariant,
        permissions: permissions,
        successBehavior: element.dataset.successBehavior || 'reload'
      },
      template: `
        <project-form :project="project" :url="url" :trigger-html="triggerHtml" :permissions="permissions"
                      :new-button-title="newButtonTitle"
                      :new-button-variant="newButtonVariant"
                      :success-behavior="successBehavior"/>`,
      components: {ProjectForm}
    })
  });
};

const initializeCustomerAddToProject = function () {
  const nodeList = document.querySelectorAll('[data-behavior="customer-add-to-project"]');
  Array.from(nodeList).forEach(element => {
    new Vue({
      el: element,
      data: {
        projectsUrl: element.dataset.projectsUrl,
        projectAssetsUrl: element.dataset.projectAssetsUrl,
        assetId: element.dataset.assetId
      },
      template: `
        <add-to-project :projects-url="projectsUrl" :project-assets-url="projectAssetsUrl" :asset-id="assetId"/>`,
      components: {AddToProject}
    })
  });
};

const initializeSingleAssetPurchaseForm = function () {
  const element = document.querySelector('#single-image-purchase-form');
  if (element !== undefined && element !== null) {

    const defaultPermissions = {
      allow_credit_card: true
    };

    const products = element.dataset.products ? normalize(JSON.parse(element.dataset.products)).get(Attributes.productAttributes) : [];
    const licenseAgreements = element.dataset.licenseAgreements ? normalize(JSON.parse(element.dataset.licenseAgreements)).get(Attributes.licenseAgreementAttributes) : [];
    const license = element.dataset.license ? normalize(JSON.parse(element.dataset.license)).get(Attributes.licenseAttributes) : null;
    const compLicense = element.dataset.compLicense ? normalize(JSON.parse(element.dataset.compLicense)).get(Attributes.licenseAttributes) : null;
    const permissions = element.dataset.permissions ? JSON.parse(element.dataset.permissions) : defaultPermissions;
    const imageSizes = element.dataset.imageSizes ? JSON.parse(element.dataset.imageSizes) : null;
    const sizeNames = element.dataset.sizeNames ? JSON.parse(element.dataset.sizeNames) : null;
    const availableAssetSizes = element.dataset.availableAssetSizes ? JSON.parse(element.dataset.availableAssetSizes) : [];
    const imageSizeHierarchy = element.dataset.imageSizeHierarchy ? JSON.parse(element.dataset.imageSizeHierarchy) : [];
    const subscriptionProducts = element.dataset.subscriptionProducts ? normalize(JSON.parse(element.dataset.subscriptionProducts)).get(Attributes.productAttributes) : [];

    new Vue({
      el: element,
      data: {
        products: products,
        license: license,
        compLicense: compLicense,
        licenseAgreements: licenseAgreements,
        paymentsUrl: element.dataset.paymentsUrl,
        creditExchangesUrl: element.dataset.creditExchangesUrl,
        subscriptionExchangesUrl: element.dataset.subscriptionExchangesUrl,
        assetDownloadUrl: element.dataset.assetDownloadUrl,
        assetId: element.dataset.assetId,
        assetThumbUrl: element.dataset.assetThumbUrl,
        assetMediaUrl: element.dataset.assetMediaUrl,
        assetUsage: element.dataset.assetUsage,
        assetType: element.dataset.assetType,
        availableCredits: element.dataset.availableCredits,
        availableAssetSizes: availableAssetSizes,
        imageSizes: imageSizes,
        sizeNames: sizeNames,
        imageSizeHierarchy: imageSizeHierarchy,
        defaultProductVersion: element.dataset.defaultProductVersion,
        subscriptionProducts: subscriptionProducts,
        permissions: permissions,
        activeSubscription: element.dataset.activeSubscription,
        userId: element.dataset.userId
      },
      template: `
        <SingleImagePurchaseForm :products="products"
                                 :license-agreements="licenseAgreements"
                                 :license="license"
                                 :comp-license="compLicense"
                                 :default-product-version="defaultProductVersion"
                                 :asset-download-url="assetDownloadUrl"
                                 :payments-url="paymentsUrl"
                                 :asset-id="assetId"
                                 :asset-thumb-url="assetThumbUrl"
                                 :asset-media-url="assetMediaUrl"
                                 :asset-usage="assetUsage"
                                 :asset-type="assetType"
                                 :available-asset-sizes="availableAssetSizes"
                                 :size-names="sizeNames"
                                 :permissions="permissions"
                                 :active-subscription="activeSubscription"
                                 :image-sizes="imageSizes"
                                 :image-size-hierarchy="imageSizeHierarchy"
                                 :subscription-exchanges-url="subscriptionExchangesUrl"
                                 :subscription-products="subscriptionProducts"
                                 :available-credits="availableCredits"
                                 :user-id="userId"
                                 :credit-exchanges-url="creditExchangesUrl"/>`,
      components: {SingleImagePurchaseForm}
    })
  }
};

const initializeCustomerEditProfile = function () {
  const nodeList = document.querySelectorAll('[data-behavior="customer-edit-profile"]');
  Array.from(nodeList).forEach(element => {
    const user = normalize(JSON.parse(element.dataset.user)).get(Attributes.userAttributes)
    new Vue({
      el: element,
      data: {
        usersUrl: element.dataset.usersUrl,
        user: user,
        editButton: element.dataset.editButton,
        editMode: element.dataset.editMode
      },
      template: `
        <customer-edit-profile :user="user"
                               :users-url="usersUrl"
                               :edit-button="editButton"
                               :edit-mode="editMode"/>`,
      components: {CustomerEditProfile}
    })
  });
};

const initializeCustomerEditAvatar = function () {
  const nodeList = document.querySelectorAll('[data-behavior="customer-edit-avatar"]');
  Array.from(nodeList).forEach(element => {
    new Vue({
      el: element,
      data: {
        usersUrl: element.dataset.usersUrl,
        paramName: element.dataset.paramName
      },
      template: `
        <customer-edit-avatar :users-url="usersUrl"
                              :param-name="paramName"/>`,
      components: {CustomerEditAvatar}
    })
  });
};

const initializeCustomerEditNotifications = function () {
  const nodeList = document.querySelectorAll('[data-behavior="switch-input"]');
  Array.from(nodeList).forEach(element => {
    new Vue({
      el: element,
      data: {
        name: element.dataset.name,
        value: element.dataset.value || false,
        url: element.dataset.url,
        disabled: !!element.dataset.disabled
      },
      template: `
        <switch-input :name="name" :value="value" :url="url" :disabled="disabled"/>`,
      components: {SwitchInput}
    })
  });
};

const initializeBooleanRadioSwitchInput = function () {
  const nodeList = document.querySelectorAll('[data-behavior="switch-input-boolean-radio"]');
  Array.from(nodeList).forEach(element => {
    new Vue({
      el: element,
      data: {
        name: element.dataset.name,
        value: element.dataset.value || false,
        url: element.dataset.url,
        disabled: !!element.dataset.disabled
      },
      template: `
        <switch-input-boolean-radio :name="name" :value="value" :url="url" :disabled="disabled"/>`,
      components: {SwitchInputBooleanRadio}
    })
  });
};

const initializeCustomerEditOrganizationForm = function () {
  const nodeList = document.querySelectorAll('[data-behavior="customer-edit-organization"]');
  Array.from(nodeList).forEach(element => {
    const organization = normalize(JSON.parse(element.dataset.organization)).get(Attributes.organizationAttributes)
    new Vue({
      el: element,
      data: {
        organizationsUrl: element.dataset.organizationsUrl,
        organization: organization,
        industries: JSON.parse(element.dataset.industries)
      },
      template: `
        <customer-edit-organization :organization="organization" :organizations-url="organizationsUrl"
                                    :industries="industries"/>`,
      components: {CustomerEditOrganization}
    })
  });
};

const loadReasonStore = function (element) {
  if (element.dataset.curatorRequestReasons) {
    window.reasonStore.curatorRequestReasons = JSON.parse(element.dataset.curatorRequestReasons)
  }

  if (element.dataset.curatorRejectReasons) {
    window.reasonStore.curatorRejectReasons = JSON.parse(element.dataset.curatorRejectReasons)
  }

  if (element.dataset.curatorAssetRemovalReasons) {
    window.reasonStore.curatorAssetRemovalReasons = JSON.parse(element.dataset.curatorAssetRemovalReasons)
  }
}

const initializeAlgoliaAdminSearch = function () {
  const element = document.querySelector('#admin-image-search-app');
  if (element !== undefined && element !== null) {
    const dataJson = editAssetDataJson(element);
    window.tagStore.updateWithTagStoreDataObject(dataJson);

    loadReasonStore(element)

    new Vue({
      el: element,
      data: {
        algoliaAppID: POCConfig.ALGOLIA_APP_ID,
        algoliaSearchKey: POCConfig.ALGOLIA_ADMIN_SEARCH_KEY,
        algoliaIndexName: element.dataset.algoliaIndexName,
        tagCategoryOrder: JSON.parse(element.dataset.tagCategoryOrder),
        categories: JSON.parse(element.dataset.categories),
        readonly: element.dataset.readonly === 'true',
        tagStore: window.tagStore,
        assetsUrl: element.dataset.url
      },
      template: `
        <CuratorAssetSearchApp :algolia-app-id="algoliaAppID"
                               :algolia-search-key="algoliaSearchKey"
                               :algolia-index-name="algoliaIndexName"
                               :readonly="readonly"
                               :tag-category-order="tagCategoryOrder"
                               :categories="categories"
                               :tag-store="tagStore"
                               :assets-url="assetsUrl"
        />`,
      components: {CuratorAssetSearchApp}
    })
  }
};

const initializeAlgoliaSearch = function () {
  const element = document.querySelector('#image-search-app');
  if (element !== undefined && element !== null) {
    new Vue({
      el: element,
      data: {
        algoliaAppID: POCConfig.ALGOLIA_APP_ID,
        algoliaSearchKey: POCConfig.ALGOLIA_SEARCH_KEY,
        algoliaIndexName: element.dataset.algoliaIndexName,
        projectsUrl: element.dataset.projectsUrl,
        projectAssetsUrl: element.dataset.projectAssetsUrl,
        userId: element.dataset.userId,
        submissionId: element.dataset.submissionId
      },
      template: `
        <AssetSearchApp :algolia-app-id="algoliaAppID"
                        :algolia-search-key="algoliaSearchKey"
                        :algolia-index-name="algoliaIndexName"
                        :project-assets-url="projectAssetsUrl"
                        :projects-url="projectsUrl"
                        :submission-id="submissionId"
                        :user-id="userId"/>`,
      components: {AssetSearchApp}
    })
  }
};

const initializeCollectionForm = function () {
  const nodeList = document.querySelectorAll('[data-behavior="collection-form"]');
  Array.from(nodeList).forEach(element => {
    let collection = {}
    if (element.dataset.collection) {
      const collectionJSON = JSON.parse(element.dataset.collection)
      collection = normalize(collectionJSON).get(Attributes.collectionAttributes.concat(Attributes.prefixed("organizations", Attributes.organizationAttributes)))
    }

    new Vue({
      el: element,
      data: {
        url: element.dataset.url,
        collection: collection,
      },
      template: `
        <collection-form :collection="collection" :url="url"/>`,
      components: {CollectionForm}
    })
  });
};

const initializeCuratorCollectionAssetsList = function () {
  const element = document.querySelector('#curator-collection-images-list');
  if (element !== undefined && element !== null) {
    const assetsJson = assetsListJson(element);
    const collectionJson = element.dataset.collection ? normalize(JSON.parse(element.dataset.collection)).get(Attributes.collectionAttributes) : null;

    new Vue({
      el: element,
      data: {
        assets: assetsJson,
        tagCategoryPriority: JSON.parse(element.dataset.tagCategoryPriority),
        collection: collectionJson,
        collectionsUrl: element.dataset.collectionsUrl,
        collectionAssetsUrl: element.dataset.collectionAssetsUrl
      },
      template: `
        <CuratorCollectionAssets :assets="assets"
                                 :tag-category-priority="tagCategoryPriority"
                                 :collections-url="collectionsUrl"
                                 :collection="collection"
                                 :collection-assets-url="collectionAssetsUrl"/>`,
      components: {CuratorCollectionAssets}
    })
  }
};

const initializeCustomerPlans = function () {
  const element = document.querySelector('#plans-selector');

  if (element !== undefined && element !== null) {
    const plans = normalize(JSON.parse(element.dataset.plans)).get(Attributes.plansAttributes)
    const commercialProducts = element.dataset.commercialProducts ? normalize(JSON.parse(element.dataset.commercialProducts)).get(Attributes.productAttributes) : [];
    const editorialProducts = element.dataset.editorialProducts ? normalize(JSON.parse(element.dataset.editorialProducts)).get(Attributes.productAttributes) : [];

    new Vue({
      el: element,
      data: {
        plans: plans,
        commercialProducts: commercialProducts,
        editorialProducts: editorialProducts,
        code: element.dataset.code,
        descriptions: JSON.parse(element.dataset.descriptions),
        agreement: element.dataset.agreement
      },
      template: `
        <Plans :plans="plans"
               :agreement="agreement"
               :commercial-products="commercialProducts"
               :code="code"
               :editorial-products="editorialProducts"
               :descriptions="descriptions"/>`,
      components: {Plans}
    })
  }
};

const initializeNewSubscription = function () {
  const element = document.querySelector('#new-subscription');

  if (element !== undefined && element !== null) {
    const plan = normalize(JSON.parse(element.dataset.plan)).get(Attributes.plansAttributes)
    const paymentMethods = normalize(JSON.parse(element.dataset.paymentMethods)).get(Attributes.paymentMethodAttributes);
    const organization = normalize(JSON.parse(element.dataset.organization)).get(Attributes.organizationAttributes);

    new Vue({
      el: element,
      data: {
        plan: plan,
        priceId: element.dataset.priceId,
        agreement: element.dataset.agreement,
        paymentMethodsManagerData: {
          paymentMethodsUrl: element.dataset.paymentMethodsUrl,
          paymentMethods: paymentMethods,
          maxPaymentMethods: parseInt(element.dataset.maxPaymentMethods, 10),
          organization: organization
        }
      },
      template: `
        <NewSubscription :plan="plan"
                         :price-id="priceId"
                         :agreement="agreement"
                         :payment-methods-manager-data="paymentMethodsManagerData"/>`,
      components: {NewSubscription}
    })
  }
};

const initializeEditSubscription = function () {
  const element = document.querySelector('#edit-subscription');

  if (element !== undefined && element !== null) {
    const plans = normalize(JSON.parse(element.dataset.plans)).get(Attributes.plansAttributes)
    const paymentMethods = normalize(JSON.parse(element.dataset.paymentMethods)).get(Attributes.paymentMethodAttributes);
    const organization = normalize(JSON.parse(element.dataset.organization)).get(Attributes.organizationAttributes);
    const subscription = element.dataset.subscription ? normalize(JSON.parse(element.dataset.subscription)).get(Attributes.subscriptionAttributes) : null
    new Vue({
      el: element,
      data: {
        plans: plans,
        currentPriceId: element.dataset.currentPriceId,
        username: element.dataset.username,
        subscription: subscription,
        paymentMethodsManagerData: {
          paymentMethodsUrl: element.dataset.paymentMethodsUrl,
          paymentMethods: paymentMethods,
          maxPaymentMethods: parseInt(element.dataset.maxPaymentMethods, 10),
          selectedPaymentMethodId: element.dataset.selectedPaymentMethodId,
          organization: organization
        }
      },
      template: `
        <EditSubscription :plans="plans"
                          :current-price-id="currentPriceId"
                          :username="username"
                          :subscription="subscription"
                          :payment-methods-manager-data="paymentMethodsManagerData"/>`,
      components: {EditSubscription}
    })
  }
};

const initializeGenericVue = function () {
  const nodeList = document.querySelectorAll('[data-behavior="vue"]');
  Array.from(nodeList).forEach(element => {
    new Vue({
      el: element
    })
  })

}

const initializeWrapVue = function () {
  const nodeList = document.querySelectorAll('[data-behavior="wrapvue"]');
  if (Array.from(nodeList).length === 0) return;

  Array.from(nodeList).forEach(element => {
    new Vue({
      el: element
    })
  })
}
$(function () {
  Vue.http.headers.common['X-CSRF-Token'] = window.POC.csrfToken();
  initializeWrapVue();
  initializeGenericVue();
  initializeUploader();
  initializeFileInput();
  initializeSampleAssetRejectForm();
  initializeSubmissionUploader();
  initializeEditReleaseForms();
  initializeModalAssets();
  initializeModalImages();
  initializeCuratorAssets();
  initializeCuratorAssetsV2();
  initializeSearchAssetsList();
  initializeModalNavigation();
  initializeCuratorSingleAssetEdit();
  initializeFeaturedItems();
  initializeFeaturedAssets();
  initializePaymentMethod();
  initializeOrganizationBilling();
  initializePaymentManager();
  initializeProjectForm();
  initializeCustomerAddToProject();
  initializeSingleAssetPurchaseForm();
  initializeCustomerEditProfile();
  initializeCustomerEditAvatar();
  initializeCustomerEditNotifications();
  initializeCustomerEditOrganizationForm();
  initializeAlgoliaSearch();
  initializeAlgoliaAdminSearch();
  initializeCollectionForm();
  initializeCuratorCollectionAssetsList();
  initializeCustomerPlans();
  initializeNewSubscription();
  initializeEditSubscription();
  initializeBooleanRadioSwitchInput();

  Plyr.setup('.plyr-video')
})